import React, { useEffect, useState } from "react";
import { X } from "lucide-react";
import { COLOR_PALETTE } from "./utils";

// Per-staff colour tag applied to a client. Closes the popover on
// outside click; onChange(hex|null) is called when the user picks or
// clears the tag.
export function ClientColorChip({ clientId, color, onChange }) {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!open) return;
    const handler = (e) => {
      if (!e.target.closest?.(`[data-color-chip="${clientId}"]`)) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [open, clientId]);

  const dotStyle = color ? { background: color } : {};
  return (
    <div
      data-color-chip={clientId}
      className="relative"
      onClick={(e) => e.stopPropagation()}
    >
      <button
        type="button"
        onClick={(e) => {
          e.preventDefault();
          setOpen((v) => !v);
        }}
        data-testid={`prod-client-color-${clientId}`}
        title="Cambia il colore di questo cliente"
        className={`h-8 w-8 rounded-full border-2 border-[var(--mp-ink)] transition-transform hover:scale-105 ${
          color ? "" : "bg-white"
        }`}
        style={dotStyle}
      />
      {open && (
        <div
          data-testid={`prod-client-color-popover-${clientId}`}
          className="absolute left-0 top-10 z-50 rounded-2xl border-2 border-[var(--mp-ink)] bg-white p-2 shadow-lg flex items-center gap-1.5"
        >
          {COLOR_PALETTE.map((c) => (
            <button
              key={c.hex}
              type="button"
              onClick={() => {
                onChange(c.hex);
                setOpen(false);
              }}
              title={c.name}
              data-testid={`prod-client-color-pick-${clientId}-${c.hex.replace("#", "")}`}
              className={`h-6 w-6 rounded-full border-2 hover:scale-110 transition-transform ${
                color === c.hex ? "border-[var(--mp-ink)]" : "border-transparent"
              }`}
              style={{ background: c.hex }}
            />
          ))}
          {color && (
            <button
              type="button"
              onClick={() => {
                onChange(null);
                setOpen(false);
              }}
              title="Rimuovi colore"
              data-testid={`prod-client-color-clear-${clientId}`}
              className="h-6 w-6 rounded-full border-2 border-[var(--mp-border)] bg-white grid place-items-center hover:bg-stone-50"
            >
              <X className="h-3 w-3" />
            </button>
          )}
        </div>
      )}
    </div>
  );
}
